import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorklogService {

  constructor(private api : ApiService) { }

  getBudgets(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}pms-service/budget/getBudgets?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  } 

addOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'pms-service/budget/addOrUpdate')
  return this.api.post(url,formData);
}
bulkAddOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'pms-service/budget/bulkAddOrUpdate')
  return this.api.post(url,formData);
}
getRoleMappingList(){
  const url = `${environment.New_BASE_DOMAIN}auth-service/role/getRoleMappingList`;
  return this.api.get(url);
} 

getWorklogs(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}pms-service/worklog/getWorklogs?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
addUpdateWorklog(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'pms-service/worklog/processWorklogInfo')
  return this.api.post(url,formData);
}
addMultiWorklogs(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'pms-service/worklog/addMultiWorklogs')
  return this.api.post(url,formData);
}
getWorkSummary(formData:any){
  const url = `${environment.New_BASE_DOMAIN}pms-service/worklog/getWorklogSummary`;
  return this.api.post(url,formData);
}
deleteWorklogInfo(id:any){
  const url = `${environment.New_BASE_DOMAIN}pms-service/worklog/deleteWorklogInfo?worklogId=${id}`;
  return this.api.delete(url);
}
getWorklogStatus(){
  const url = `${environment.New_BASE_DOMAIN}pms-service/master/getWorkLogMasterStatusList`;
  return this.api.get(url);
}

}
